/* Keep the exact resource, query (including variants) and guide anchor when switching language.
   Shopify's localization endpoint resolves any translated resource handle. */
function enablePreviewLanguageChoice() {
  // Shopify's actual theme role also identifies a standalone merchant preview.
  // A URL query alone is not proof of a preview. Unknown/live roles stay closed.
  const role = window.Shopify?.theme?.role;
  if (role !== 'unpublished' && role !== 'development') return;
  document.querySelectorAll('.zv-language-selector[data-zv-preview-only], .zv-language-selector [data-zv-preview-only]')
    .forEach((element) => element.removeAttribute('data-zv-preview-only'));
}
enablePreviewLanguageChoice();
document.addEventListener('shopify:section:load', enablePreviewLanguageChoice);

function initializeLanguageDropdowns() {
  document.querySelectorAll('.zv-language-disclosure').forEach((details) => {
    if (details.dataset.zvLanguageReady) return;
    details.dataset.zvLanguageReady = 'true';
    const summary = details.querySelector('summary');
    let hoverOpened = false;
    details.addEventListener('pointerenter', (event) => {
      if (event.pointerType === 'touch' || !window.matchMedia('(hover: hover)').matches) return;
      hoverOpened = true;
      details.open = true;
    });
    details.addEventListener('pointerleave', (event) => {
      if (event.pointerType === 'touch') return;
      hoverOpened = false;
      if (!details.contains(document.activeElement)) details.open = false;
    });
    summary.addEventListener('click', (event) => {
      if (hoverOpened && event.detail > 0 && details.open) event.preventDefault();
    });
    details.addEventListener('focusout', (event) => {
      // Safari touch can blur the summary before the option receives its click.
      if (event.relatedTarget && !details.contains(event.relatedTarget)) details.open = false;
    });
    details.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      details.open = false;
      summary.focus();
      event.preventDefault();
    });
  });
}
initializeLanguageDropdowns();
document.addEventListener('shopify:section:load', initializeLanguageDropdowns);
document.addEventListener('pointerdown', (event) => {
  document.querySelectorAll('.zv-language-disclosure[open]').forEach((details) => {
    if (!details.contains(event.target)) details.open = false;
  });
});

document.addEventListener('submit', (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.classList.contains('zv-language-selector')) return;
  // Visitor previews return their default locale after POST /localization.
  // On the homepage, Shopify supplies the exact locale root; navigate within
  // the same preview instead. Other pages keep native translated-handle routing.
  const localeRoot = event.submitter?.dataset.zvLanguageRoot;
  if (!event.defaultPrevented
    && /^[a-z0-9]+-\d+\.shopifypreview\.com$/i.test(window.location.hostname)
    && form.dataset.zvLanguageHomepage === 'true'
    && typeof localeRoot === 'string' && /^\/(?!\/)/.test(localeRoot)) {
    const destination = new URL(localeRoot, window.location.origin);
    if (destination.origin === window.location.origin) {
      destination.search = window.location.search;
      destination.hash = window.location.hash;
      event.preventDefault();
      window.location.assign(destination.href);
      return;
    }
  }
  let input = form.querySelector('input[name="return_to"]');
  if (!input) {
    input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'return_to';
    form.appendChild(input);
  }
  input.value = window.location.pathname + window.location.search + window.location.hash;
});
